import React from 'react';
import './Cadastro.css';
import FormCadastro from '../../components/cadastro/form_cadastro'; // Nome corrigido

function Cadastro() {
    return (
        <FormCadastro /> // Nome do componente atualizado
    );
}

export default Cadastro;
